import API from "../BaseURL";

const configJson = {
    headers: {
        "content-type": "application/json",
    },
};



export async function getAllProducts() {
    const res = API.get(`/products/`, configJson);
    return res;
}

export async function getProductInfo(product_id) {
    const res = API.get(`/products/${product_id}`, configJson);
    return res;
}

export async function createProduct(data) {
    const res = API.post(`/products/`, data, configJson);
    return res;
}

export async function updateProduct(product_id, data) {
    const res = API.put(`/products/${product_id}/`, data, configJson);
    return res;
}

export async function deleteProduct(product_id) {
    const res = API.delete(`/products/${product_id}/`, configJson);
    return res;
}


export async function getProductByExploitation(exploitation_id) {
    const res = API.get(`/products/exploitation/${exploitation_id}`, configJson);
    return res;
}